/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserShareV20OrganizationCoordinationShareDelete$Params {

/**
 * The id of the Organization.
 */
  organizationId: string;

/**
 * The id of the Coordination.
 */
  coordinationId: string;

/**
 * The id of the Share.
 */
  id: string;
  'api-version'?: string;
}

export function userShareV20OrganizationCoordinationShareDelete(http: HttpClient, rootUrl: string, params: UserShareV20OrganizationCoordinationShareDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userShareV20OrganizationCoordinationShareDelete.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('coordinationId', params.coordinationId, {});
    rb.path('id', params.id, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userShareV20OrganizationCoordinationShareDelete.PATH = '/api/user-share/v2-0/organization/{organizationId}/coordination/{coordinationId}/share/{id}';
